import Rapport from '@ifit/rapport-webview';
import { I18nWebview } from '@ifit/rapport-webview/lib/i18n-webview';
import rapportWebPackage from '../rapport-web.json';

const i18n = Rapport.initI18n(rapportWebPackage) as I18nWebview;

export default i18n;
